import axios from "axios";
import {environmentConfig} from "@/config/enviromentConfig";

export default class WorldPlayService {
    static async getUser(msisdn, productId) {
        const response = await axios.post(`${environmentConfig.worldPlayHost}/get-user`, {
            msisdn: msisdn,
            productId: productId,
        })
        return response.data;
    }

    static async updateUsername(msisdn, productId, username) {
        const response = await axios.post(`${environmentConfig.worldPlayHost}/update-username`, {
            msisdn: msisdn,
            productId: productId,
            username: username,
        })
        return response.data;
    }

}
